import { useQuery } from '@tanstack/react-query';
import { listAllUsuarios, type UsuarioItem } from '@/shared/api/controllers/usuarios';

export const USUARIOS_QUERY_KEY = ['configuracion', 'usuarios'] as const;

export function useAllUsuarios() {
  return useQuery<UsuarioItem[]>({
    queryKey: USUARIOS_QUERY_KEY,
    queryFn: listAllUsuarios,
    staleTime: 60_000,
  });
}
